/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import useForm from '../../hooks/useForm';
import { ControlTable } from '../Table';
import Filters from '../Filters';
import { getParams } from '../../utils/params';
import { getMailUnsubscribes } from '../../apis/admin/mailUnsubscribes';

const UNSUBSCRIBE_TYPE = [
  { label: "뉴스레터", type: "newsletter" }
];

const MailUnsubscribes = () => {
  const [fields] = useState([
    { title: "이름", key: "name" },
    { title: "연락처", key: "mobile" },
    { title: "이메일", key: "email" },
    { title: "수신거부일", key: "createdTime", type: "datetime" },
    {
      title: "수신거부 항목", key: "type", onValue: (d) => {
        switch (d) {
          case "newsletter":

            return "뉴스레터";
          default:
            return "-";
        }
      }
    },
  ]);
  const [filters] = useState([
    {
      title: "이름",
      key: "search.name",
    },
    {
      title: "이메일",
      key: "search.email",
    },
    {
      title: "수신거부 항목",
      type: "select",
      key: "search.type",
      defaultValue: '',
      options: {
        list: [
          { label: "전체", value: '' },
          ...UNSUBSCRIBE_TYPE.map(t => ({ label: t.label, value: t.type }))
        ]
      },
    }
  ]);

  const {
    form,
    setSubmit,
    handleOnChange,
    // handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm({
    order: [
      {
        createdTime: "desc"
      },
    ],
    page: 0,
    limit: 10
  },);

  const submit = (param) => {
    setIsLoading(true);
    getMailUnsubscribes(getParams(param))
      .then(res => {
        const { rows, count } = res.unsubscribes || { rows: [], count: 0 };
        setTotal(count);
        setList(rows);
      })
      .catch(() => { })
      .finally(() => setIsLoading(false));
  };


  useEffect(() => {
    submit(form);
    setSubmit(submit);
  }, []);


  return (
    <>
      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />

      <ControlTable
        fields={fields}
        list={list}
        isLoading={isLoading}
        selectedList={selectedList}
        setSelected={setSelectedList}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        isControl={false}
      // buttons={tableButtons}
      />


    </>
  );
};

export default MailUnsubscribes;